import drawLine from "./drawLine.js";
import drawPolygon from "./drawPolygon.js";

/**
 * Draw an arrow using the drawing API.
 * @public
 * @method drawArrow
 * @memberof Drawing
 *
 * @param  {Object} context   The canvas context.
 * @param  {Object} start     The start position.
 * @param  {Object} end       The end position.
 * @param  {string} color     The color of the arrow.
 * @param  {number} lineWidth The width of the arrow line.
 * @returns {undefined}
 */
export default function(context, element, start, end, options) {
  // Variables to be used when creating the arrow

  const defaultLineWidth = 3;
  const defaultStrokeColor = "#ffffff";
  const defaultFillColor = "#ffffff";
  const defaultHeadLength = 15;

  // eslint-disable-next-line no-unused-vars
  let { color, lineWidth, headLength, fillColor } = options;

  color = color ? color : defaultStrokeColor;
  lineWidth = lineWidth ? lineWidth : defaultLineWidth;
  headLength = headLength ? headLength : defaultHeadLength;
  fillColor = fillColor ? fillColor : defaultFillColor;

  /// Viewport 배율 변화에 따른, 화살표 도형의 최소 스케일 유지.
  if (options.minArrowScale) {
    const { viewScale, lowerBoundScale } = options.minArrowScale;
    if (viewScale < lowerBoundScale) {
      const upscale = (1 / viewScale) * lowerBoundScale;
      headLength = headLength * upscale;
    }
  }

  const angle = Math.atan2(end.y - start.y, end.x - start.x);

  // Starting path of the arrow from the start square to the end square and drawing the stroke

  const lineEndPoint = {
    x: end.x - (headLength - 2) * Math.cos(angle),
    y: end.y - (headLength - 2) * Math.sin(angle)
  };

  const lineOptions = {
    color,
    lineWidth
  };

  drawLine(context, element, start, lineEndPoint, lineOptions, "pixel");
  const points = [
    {
      x: end.x - headLength * Math.cos(angle - Math.PI / 7),
      y: end.y - headLength * Math.sin(angle - Math.PI / 7)
    },
    {
      x: end.x - headLength * Math.cos(angle + Math.PI / 7),
      y: end.y - headLength * Math.sin(angle + Math.PI / 7)
    },
    end
  ];

  const polygonOptions = {
    color: "#ffffff00",
    lineWidth,
    fillStyle: color
  };
  drawPolygon(context, element, points, polygonOptions, "pixel");
}
